// extracted by mini-css-extract-plugin
export default {"Plaintext":"OvUdA"};